// import React from 'react';
// import { motion } from 'framer-motion';
// import Footer from '../../../components/Footer';
// import BtechImg from '../../../assets/images/engineering.jpeg';
// import { Link } from 'react-router-dom';
// import { GraduationCap } from 'lucide-react';

// const BtechCSE = () => {
//     return (
//         <div className="w-full relative font-poppins bg-gray-50">
//             <div className="w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-8">
//                 {/* Header Section */}
//                 <motion.div
//                     initial={{ opacity: 0, y: -20 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     className="text-center"
//                 >
//                     <h2 className="mb-4 text-2xl md:text-6xl tracking-tight font-bold text-[#0e4d38]">
//                         Bachelor of Technology in Computer Science Engineering
//                     </h2>
//                     <motion.div
//                         className="w-[20%] mx-auto h-[6px] bg-[#23376c]"
//                         initial={{ width: 0 }}
//                         animate={{ width: "20%" }}
//                         transition={{ delay: 0.5 }}
//                     />
//                 </motion.div>

//                 {/* About Section */}
//                 <motion.div
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     transition={{ delay: 0.2 }}
//                     className="flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] items-center"
//                 >
//                     <motion.img
//                         src={BtechImg}
//                         alt=" in Computer Science"
//                         className="md:w-[40%] rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300"
//                         whileHover={{ scale: 1.02 }}
//                         transition={{ duration: 0.3 }}
//                     />
//                     <div className="flex flex-col gap-6 bg-white p-6 rounded-xl shadow-lg">
//                         <h4 className="font-bold text-xl md:text-3xl text-[#0e4d38]">About the Department</h4>
//                         <p className="text-justify md:text-lg">
//                             At our esteemed department, we pride ourselves on fostering innovation, creativity, and excellence in the ever-evolving fields of computer science and engineering. The department offers  programs in Computer Science and Engineering, AI and ML, Cyber Security, Cloud Computing, Data Science, and an M.Tech in AI and ML, Data Science. Our programs provide a solid foundation in theory and hands-on experience in cutting-edge technologies.
//                         </p>
//                         <Link to="https://admission.maya.edu.in/">
//                             <button className="mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3]">
//                                 Register Now
//                             </button>
//                         </Link>
//                     </div>
//                 </motion.div>

//                 {/* Eligibility Section */}
//                 <FeatureList
//                     title="Eligibility Criteria"
//                     items={[
//                         "Intermediate / 10+2 with PCM from a recognized board.",
//                         "Admission through MDU Entrance Examination.",
//                     ]}
//                     icon={<GraduationCap className="text-[#0e4d38]" />}
//                 />

//                 {/* Programme Details Table */}
//                 <motion.div
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     viewport={{ once: true }}
//                     className="bg-white p-6 rounded-xl shadow-lg"
//                 >
//                     <h4 className="text-2xl font-semibold text-[#0e4d38] mb-4">Programme Details</h4>
//                     <div className="overflow-x-auto">
//                         <table className="min-w-full text-center text-sm font-light">
//                             <thead className="border-b bg-[#23376c] font-medium text-white">
//                                 <tr>
//                                     <th className="px-6 py-4">Programme</th>
//                                     <th className="px-6 py-4">Branch/Specialization</th>
//                                     <th className="px-6 py-4">Duration</th>
//                                     <th className="px-6 py-4">Seats</th>
//                                     <th className="px-6 py-4">One-time Charges</th>
//                                     <th className="px-6 py-4">Yearly Fee (All India)</th>
//                                     <th className="px-6 py-4">Yearly Fee (UK Domicile)</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 <tr className="border-b">
//                                     <td className="px-6 py-4 font-semibold">.</td>
//                                     <td className="px-6 py-4">Computer Science & Engineering</td>
//                                     <td className="px-6 py-4">4 Years</td>
//                                     <td className="px-6 py-4">60</td>
//                                     <td className="px-6 py-4">Rs. 21,000/-</td>
//                                     <td className="px-6 py-4">Rs. 1,45,000/-</td>
//                                     <td className="px-6 py-4">Rs. 1,05,000/-</td>
//                                 </tr>
//                             </tbody>
//                         </table>
//                     </div>
//                 </motion.div>

//                 {/* Note Section */}
//                 <motion.div
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     viewport={{ once: true }}
//                     className="bg-[#23376c] p-6 rounded-xl text-center text-white italic font-semibold mt-10"
//                 >
//                     <p>* From 2nd year, scholarship is offered only on 75% attendance and no backlogs.</p>
//                     <p>** Applicable on courses with lower fees for siblings.</p>
//                 </motion.div>
//             </div>

//             {/* Footer */}
//             <Footer />
//         </div>
//     );
// };

// const FeatureList = ({ title, items, icon }) => (
//     <motion.div
//         initial={{ opacity: 0, y: 20 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         viewport={{ once: true }}
//         className="flex flex-col gap-4 bg-white p-6 rounded-xl shadow-lg"
//     >
//         <div className="flex items-center gap-3">
//             {icon}
//             <h4 className="text-2xl font-semibold text-[#0e4d38]">{title}</h4>
//         </div>
//         <ul className="list-disc ml-8 space-y-2">
//             {items.map((item, index) => (
//                 <motion.li
//                     key={index}
//                     initial={{ opacity: 0, x: -20 }}
//                     whileInView={{ opacity: 1, x: 0 }}
//                     transition={{ delay: index * 0.1 }}
//                 >
//                     {item}
//                 </motion.li>
//             ))}
//         </ul>
//     </motion.div>
// );

// export default BtechCSE;




import React from 'react';
import Footer from '../../../components/Footer';
import BtechImg from "../../../assets/images/engineering.jpeg"; // Update with a relevant cyber security image
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
    Shield,
    GraduationCap,
    Lock,
    Target,
    BookOpen,
    FlaskConical,
    MapPin,
    Users,
    Code,
} from 'lucide-react';

const BtechCSE = () => {
    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };

    return (
        <div className='w-full relative font-poppins'>
            {/* Hero Section */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className='relative h-[300px] md:h-[400px] bg-[#0e4d38] mt-[60px] md:mt-[80px] overflow-hidden'
            >
                <div className='absolute inset-0 bg-black/50'></div>
                <div className='relative z-10 h-full flex flex-col justify-center items-center text-white px-4'>
                    <h1 className='text-3xl md:text-6xl font-bold text-center mb-4'>
                        Bachelor of Technology in <br /> Computer Science Engineering (CSE)
                    </h1>
                </div>
            </motion.div>

            <div className='w-11/12 md:w-10/12 mx-auto mt-8 md:mt-16'>
                {/* About Section */}
                <motion.div
                    {...fadeIn}
                    className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px]'
                >
                    <img src={BtechImg} className='md:w-[40%] rounded-xl shadow-lg' alt="Cyber Security" />
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center gap-3'>
                            <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                                <Shield size={24} />
                            </div>
                            <h4 className='font-bold text-2xl md:text-3xl text-[#0e4d38]'>Program Overview</h4>
                        </div>
                        <div className='text-justify md:text-lg space-y-4 text-gray-700'>
                            A Bachelor of Technology (B.Tech.) in Computer Science Engineering (CSE) is designed to build a strong foundation in computing principles, algorithms, software development, and advanced technologies like artificial intelligence, machine learning, and cloud computing. This program emphasizes both theoretical knowledge and practical skills, enabling students to excel in software development, data analytics, cybersecurity, and various other roles in the tech industry.
                            <br />
                            Graduates from this program are highly sought after by top tech companies, startups, and research organizations, with opportunities in fields such as software engineering, AI research, cloud solutions architecture, and data science.
                        </div>
                        <Link to="https://admission.maya.edu.in/">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className='mt-5 md:mt-4 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2'
                            >
                                <GraduationCap size={20} />
                                Apply Now
                            </motion.button>
                        </Link>
                    </div>
                </motion.div>

                {/* Learning Outcomes */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Target size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Learning Outcomes</h4>
                    </div>
                    <p className='text-gray-700 leading-relaxed mb-4'>
                        The B.Tech in CSE program ensures that students acquire a diverse skill set to become well-rounded computing professionals. Key learning outcomes include:
                    </p>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "• Proficiency in Software Development",
                            "• Strong Understanding of Data Structures & Algorithms",
                            "• Hands-on Experience in Artificial Intelligence & Machine Learning",
                            "• Knowledge of Cloud Computing & Virtualization",
                            "• Mastery in Database Design & Management",
                            "• Understanding of Cybersecurity Principles",
                            "• Ability to Work on Real-world Projects",
                            "• Problem-Solving and Analytical Thinking Skills"
                        ].map((role, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{role}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Laboratories and Facilities */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Code size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Laboratories and Facilities</h4>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "• Programming Lab",
                            "• AI & Machine Learning Lab",
                            "• Cloud Computing Lab",
                            "• Data Science Lab",
                            "• Database Systems Lab",
                            "• IoT & Embedded Systems Lab"
                        ].map((lab, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{lab}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Admission Requirements */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-xl shadow-lg mb-12"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <div className="p-2 rounded-lg bg-[#0e4d38] text-white">
                            <GraduationCap size={24} />
                        </div>
                        <h4 className="font-bold text-2xl text-[#0e4d38]">Admission Requirements</h4>
                    </div>

                    <div className="space-y-4">
                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Duration of the Program:</span> 4 Years (Semester System)
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Affiliation:</span> Constituent College of Maya Devi University
                            </p>
                        </div>

                        <div className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full mt-2"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Eligibility Criteria:</span> Candidate shall have Passed 12th Examination with Physics, Chemistry, and Mathematics subjects and should have obtained at least 45% in case of general category and 40% in case of reserved category from a recognized board.
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Mode of Admission:</span> As per university procedure
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default BtechCSE;
